// import { Facebook, Linkedin, Youtube } from 'components/Icons'
import { useContext } from 'react'
import { AppContext } from 'contexts/AppContext'
import { Link } from 'react-router-dom'
import {
  FacebookLogo,
  InstagramLogo,
  LinkedinLogo,
  YoutubeLogo,
} from 'phosphor-react'
import { Wrapper } from 'components'
import { formatPortuguesePhone } from 'utils/formatPhone'

export const Footer = () => {
  const { settings } = useContext(AppContext)

  // if (!settings) {
  //   return <></>
  // }

  const fbLink = settings?.socialNetworkFacebook || ''
  const instaLink = settings?.socialNetworkInstagram || ''
  const liLink = settings?.socialNetworkLinkedin || ''
  const ytLink = settings?.socialNetworkYouTube || ''
  const phoneForContacts = settings?.phoneForContacts || ''
  const emailThatReceivesContacts = settings?.emailThatReceivesContacts || ''

  return (
    <footer className="fixed bottom-0 left-0 w-screen bg-black/30 backdrop-blur-sm">
      <Wrapper>
        <div className="flex justify-center items-center gap-16 py-6">
          <Link to="https://innovarisk.pt">
            <img
              src="/images/logo_footer.png"
              alt="Innorisk"
              className="w-32 h-auto"
            />
          </Link>

          <div className="space-y-4">
            <h3 className="text-body-4 font-light uppercase text-white tracking-widest border-b border-white pb-1">
              contactos
            </h3>
            <div className="flex gap-4">
              <Link
                to={`tel:${phoneForContacts}`}
                className="text-body-5 text-white underline"
              >
                {formatPortuguesePhone(phoneForContacts)}
              </Link>
              <Link
                to={`mailto:${emailThatReceivesContacts}`}
                className="text-body-5 text-white underline"
              >
                {emailThatReceivesContacts}
              </Link>
            </div>
          </div>
          <div className="flex gap-4 items-center text-white">
            <Link target="_blank" rel="noreferrer" to={liLink!}>
              <LinkedinLogo size={24} weight="fill" className="text-white" />
            </Link>
            <Link target="_blank" rel="noreferrer" to={fbLink!}>
              <FacebookLogo size={24} weight="fill" className="text-white" />
            </Link>
            <Link target="_blank" rel="noreferrer" to={instaLink!}>
              <InstagramLogo size={24} weight="fill" className="text-white" />
            </Link>
            <Link target="_blank" rel="noreferrer" to={ytLink!}>
              <YoutubeLogo size={24} weight="fill" className="text-white" />
            </Link>
          </div>
        </div>
      </Wrapper>
    </footer>
  )
}

export default Footer
